import React from 'react';
import PropTypes from 'prop-types';
import { ListContainer, ListItem } from './styles';

function List(props) {
  const { children, striped } = props;

  return (
    <ListContainer striped={striped}>
      {children.map((item, i) => (
        <ListItem key={i}>{item}</ListItem>
      ))}
    </ListContainer>
  );
}

List.propTypes = {
  striped: PropTypes.bool,
  children: PropTypes.node.isRequired,
};

List.defaultProps = {
  striped: true,
};

export default List;
